"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from "next/navigation";
import React, { useCallback, useMemo, useRef } from "react";
import { getActiveWaveIdFromUrl, getNotificationsRoute } from "@/helpers/navigation.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useWave } from "@/hooks/useWave";
import { useWaveData } from "@/hooks/useWaveData";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import BellIcon from "../common/icons/BellIcon";
import ChatBubbleIcon from "../common/icons/ChatBubbleIcon";
import DiscoverIcon from "../common/icons/DiscoverIcon";
import LogoIcon from "../common/icons/LogoIcon";
import CollectionsMenuIcon from "../common/icons/CollectionsMenuIcon";
import UsersIcon from "../common/icons/UsersIcon";
import WavesIcon from "../common/icons/WavesIcon";
import NavItem from "./NavItem";
import type { NavItem as NavItemData } from "./navTypes";
const items: NavItemData[] = [{
  kind: "route",
  name: "Discovery",
  href: "/discover",
  icon: "discover",
  iconComponent: DiscoverIcon
}, {
  kind: "view",
  name: "Waves",
  viewKey: "waves",
  icon: "waves",
  iconComponent: WavesIcon,
  iconSizeClass: "tw-size-6"
}, {
  kind: "view",
  name: "Messages",
  viewKey: "messages",
  icon: "messages",
  iconComponent: ChatBubbleIcon
}, {
  kind: "route",
  name: "Home",
  href: "/",
  icon: "home",
  iconComponent: LogoIcon,
  iconSizeClass: "tw-size-9"
}, {
  kind: "route",
  name: "Network",
  href: "/network",
  icon: "network",
  iconComponent: UsersIcon
}, {
  kind: "route",
  name: "Collections",
  href: "/the-memes",
  icon: "collections",
  iconComponent: CollectionsMenuIcon
}, {
  kind: "route",
  name: "Notifications",
  href: "/notifications",
  icon: "notifications",
  iconComponent: BellIcon
}];
interface BottomNavigationProps {
  readonly hidden?: boolean | undefined;
}
const BottomNavigation: React.FC<BottomNavigationProps> = t0 => {
  const $ = _c(20);
  const {
    hidden: t1
  } = t0;
  const hidden = t1 === undefined ? false : t1;
  const {
    registerRef
  } = useLayout();
  const {
    isApp
  } = useDeviceInfo();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const mobileNavRef = useRef(null);
  let t2;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t2 = getActiveWaveIdFromUrl({
      pathname,
      searchParams
    });
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const waveIdFromQuery = t2;
  let t3;
  if ($[3] !== waveIdFromQuery) {
    t3 = {
      waveId: waveIdFromQuery,
      onWaveNotFound: _temp
    };
    $[3] = waveIdFromQuery;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: waveData
  } = useWaveData(t3);
  const {
    isDm: isCurrentWaveDm
  } = useWave(waveData);
  let t4;
  if ($[5] !== registerRef) {
    t4 = node => {
      mobileNavRef.current = node;
      registerRef("mobileNav", node);
    };
    $[5] = registerRef;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const setMobileNavRef = t4;
  let t5;
  if ($[7] !== isApp) {
    t5 = items.map(item => item.name === "Notifications" ? {
      ...item,
      href: getNotificationsRoute(isApp)
    } : item);
    $[7] = isApp;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const navItems = t5;
  const hiddenStyle = hidden ? "tw-opacity-0 tw-translate-y-full tw-pointer-events-none" : "tw-opacity-100 tw-translate-y-0";
  const t6 = `${hiddenStyle} tw-fixed tw-bottom-0 tw-left-0 tw-z-50 tw-h-[85px] tw-w-full tw-bg-black tw-shadow-inner tw-transition-[opacity,transform] tw-duration-75`;
  let t7;
  if ($[9] !== isCurrentWaveDm || $[10] !== navItems) {
    let t8;
    if ($[12] !== isCurrentWaveDm) {
      t8 = item_0 => <li key={item_0.name} className="tw-flex tw-h-full tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center"><NavItem item={item_0} isCurrentWaveDm={isCurrentWaveDm} /></li>;
      $[12] = isCurrentWaveDm;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t7 = navItems.map(t8);
    $[9] = isCurrentWaveDm;
    $[10] = navItems;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="tw-relative tw-h-full before:tw-absolute before:tw-inset-x-0 before:tw-top-0 before:tw-h-px before:tw-bg-iron-900 before:tw-content-['']"><ul className="tw-mx-auto tw-flex tw-h-full tw-pl-[env(safe-area-inset-left,0px)] tw-pr-[env(safe-area-inset-right,0px)] md:tw-max-w-2xl">{t7}</ul></div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== setMobileNavRef || $[17] !== t6 || $[18] !== t8) {
    t9 = <nav ref={setMobileNavRef} className={t6}>{t8}</nav>;
    $[16] = setMobileNavRef;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default BottomNavigation;
function _temp() {}